import { configuration } from "./configuration";
import { track } from '@amplitude/analytics-browser';

declare global {
    interface GlobalEventHandlersEventMap {
        track: CustomEvent<EventPayload>;
    }
}

export let lastTrackEvent: string | null = null;

export type EventPayload = {
    event?: string,
    [key: string]: any
};

export function trackData(eventPayload: EventPayload) {
    const { event, ...payload } = eventPayload;
    if (event === undefined) return;
    
    if (configuration.canTrackEvents) {
        track(event, payload);
    }
    lastTrackEvent = payload.event;
}

export function listenForLegacyEvents() {
    document.addEventListener('track', (event: CustomEvent<EventPayload>) => trackData(event.detail));
}